import { render, staticRenderFns } from "./magazine-content.vue?vue&type=template&id=26154045&scoped=true"
import script from "./magazine-content.vue?vue&type=script&lang=js"
export * from "./magazine-content.vue?vue&type=script&lang=js"
import style0 from "./magazine-content.vue?vue&type=style&index=0&id=26154045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26154045",
  null
  
)

export default component.exports